import React, { memo } from "react";
import { HighchartsReact } from "investira.react.charts";
const FinanceiroChart = memo(props => {
  const {
    data = [],
    title = {}
  } = props;
  const xOptions = {
    chart: {
      type: "pie",
      height: "260px"
    },
    title: {
      text: "",
      ...title,
      style: {
        fontSize: "0.85rem"
      }
    },
    series: [{
      name: "Percentual",
      colorByPoint: true,
      data: data.map(xItem => ({
        name: xItem.item,
        y: xItem.percentual,
        metadata: {
          tipo: xItem.tipo,
          percentual: `${xItem.percentual}%`
        }
      }))
    }],
    plotOptions: {
      pie: {
        innerSize: "50%",
        allowPointSelect: true,
        cursor: "pointer",
        borderColor: "#2e2e46",
        // Cor do contorno (borda)
        borderWidth: 2,
        // Largura do contorno
        dataLabels: {
          enabled: true,
          format: "{point.name}",
          style: {
            color: "white",
            // Muda a cor do texto para branco
            textOutline: "none",
            // Remove o outline
            fontWeight: "normal"
          }
        }
      }
    },
    tooltip: {
      formatter: function () {
        // `this.point` refere-se ao ponto (fatia) sobre o qual o mouse está
        return `<b>${this.point.name}</b></br><b>Tipo</b>: ${this.point.metadata.tipo}`;
      }
    }
  };
  return <HighchartsReact options={xOptions} drilldown />;
});
export default FinanceiroChart;
